/** https://wagmi.sh/core/api/actions/getChainId */
export function getChainId(config) {
    return config.state.chainId;
}
//# sourceMappingURL=getChainId.js.map